const baseURL = process.env.REACT_APP_JUSTTAWK_IND_BASE_API_URL;

const apiEndPointsConfig = {
  // user //

  //########  Login Details ######### //
  campaignUser: `${baseURL}/campaign-user`,
  addLogin: `${baseURL}/user/register`,
  otpVarification: `${baseURL}/User/otp`,
  resendOtp: `${baseURL}/user/resend-otp`,

  //########  Company Details ######### //
  getSingleUser: `${baseURL}/users`,
  userDetails: `${baseURL}/user/Details`,
  singleUserFieldDetails: `${baseURL}/user/singleUserFieldDetails`,
  saveCallType: `${baseURL}/user/save-Call-Type`,
  selectIndustryType: `${baseURL}/user/select-industry-type`,
  saveFaqDetails: `${baseURL}/user/save-faq-details`,
  getDidNumber: `${baseURL}/user/get-did-number`,
  saveDidNumber: `${baseURL}/user/save-did-number`,
  getAllFaqs: `${baseURL}/user/get-all-faqs`,
  updateFaqById: `${baseURL}/user/update-faq`,
  getUserCompanyDetails: `${baseURL}/user/company-details`,
  getPricing: `${baseURL}/user/get-subscription-plan`,
  getSingleBillPricing: `${baseURL}/user/get-subscription-by`,
  updateProfile: `${baseURL}/user/updated-profile`,
  getUserProfile: `${baseURL}/user/profile`,
  updateUserProfile: `${baseURL}/user/profile/update`,
  uploadProfilePhoto: `${baseURL}/user/profile/upload-photo`,
  deleteProfilePhoto: `${baseURL}/user/profile/delete-photo`,
  addFaqByAi: `${baseURL}/user/generate-faq-by-ai`,
  updateFaqByAi: `${baseURL}/user/update-faqs-by-ai`,
  sendNewUserDetailsEmail: `${baseURL}/send-mail`,
  getCustomerTicketByUser: `${baseURL}/user/get-ticket-by-id`,
  changeTicketStatus: `${baseURL}/tickets/change-status`,
  savePayment: `${baseURL}/payment/save-payment`,
  sendFaqDetailsOnMail: `${baseURL}/faq/notify-user`,
  getAllCallLogs: `${baseURL}/users/call-logs`,
  getCallLogsCountByUserId: `${baseURL}/users/call-count`,
  getUserCallLogsChart: `${baseURL}/users/call-logs-pie-chart`,
  getCallTranscript: `${baseURL}/users/call-logs-transcript`,
  getSlaReport: `${baseURL}/report/sla`,
  getConversionReport: `${baseURL}/report/conversion`,
  getUnreachedReport: `${baseURL}/report/unreached`,
  loginWithGoogle: `${baseURL}/google-login`,
  sheet: `${baseURL}/sheet`,
  loginByIdPass: `${baseURL}/idpass-login`,
  uploadLeads: `${baseURL}/upload-leads`,
  getAllLeads: `${baseURL}/get-all-leads`,

  // get campaign by user ///
  getCampaignsByUserId: `${baseURL}/campaigns`,
  getCampaignsStatus: `${baseURL}/campaigns/status`,
  deleteCampaignLeadById: `${baseURL}/campaigns-lead`,

  // google sheed
  addGoogleSheetUrl: `${baseURL}/add-google-sheet`,
  getGoogleSheetUrl: `${baseURL}/google-sheet`,
  deleteGoogleSheetUrl: `${baseURL}/remove-google-sheet`,
  getAllPaidUsers: `${baseURL}/users/paid-users`,
  syncCampaignLeadsToPipeline: `${baseURL}/campaigns/sync-to-pipeline`,

  //admin
  // loginAdmin: `${baseURL}/admin/login`,
  listOfLeads: `${baseURL}/admin/leads`,
  singlLead: `${baseURL}/admin/single-leads`,

  //agent comments
  getAllComments: `${baseURL}/get-comments`,
  addComment: `${baseURL}/add-comment`,
  editComment: `${baseURL}/edit-comment`,
  deleteComment: `${baseURL}/delete-comment`,

  ///// agent
  SaveTicket: `${baseURL}/agent/create-ticket`,
  ticketList: `${baseURL}/agent/get-all-tickets`,
  agentTicketById: `${baseURL}/agent/tickets`,

  // agent //
  loginAgent: `${baseURL}/agent/login`,
  searchByDID: `${baseURL}/agent/search-by-did`,

  //-----////
  companyDetails: `${baseURL}/Onboarding/Register`,
  companyFaqs: `${baseURL}/Onboarding/Faq`,
  getAllNumbers: `${baseURL}/Onboarding/FetchNumber`,
  customerCareNumber: `${baseURL}/Onboarding/CustomerCareNumber`,
  getFaqByAi: `${baseURL}/User/FaqByAI`,

  //########  Dasboard  ######### //
  onboardingDashboard: `${baseURL}/Onboarding/Dashboard`,
  getAllFaq: `${baseURL}/Onboarding/FaqByUser`,
  addFaqByImg: `${baseURL}/Onboarding/FaqImage`,
  editFaq: `${baseURL}/Onboarding/Faq`,
  getCallLogs: `${baseURL}/Onboarding/CallLogs`,
  getSubscriptionPlans: `${baseURL}/Payment/getSubscriptionPlan`,
  getSubscriptionPlanById: `${baseURL}/Payment/getSubscriptionPlanDetailbyID`,
  getSubscriptionResponse: `${baseURL}/Payment/SavePaymentResponse`,

  /// user ticket
  userSingleTicket: `${baseURL}/UserTicket/getTicketById`,
  userGetStatus: `${baseURL}/Agents/getStatus`,
  getTicketByUser: `${baseURL}/UserTicket/getTicketById`,
  deletCommentByUser: `${baseURL}/UserTicket/deleteComment`,
  editCommentByUser: `${baseURL}/UserTicket/editComment`,
  addCommentByUser: `${baseURL}/UserTicket/AddComment`,

  // agent //
  // loginAgent: `${baseURL}/Agents/Login/`,
  searchByNumber: `${baseURL}/Agents/searchByNumber`,
  // searchByDID: `${baseURL}/Agents/searchByDID`,
  saveWebHookData: `${baseURL}/Agents/saveWebHookData`,

  // searchByDID: `${baseURL}/Agents/searchByDID`,
  getCategory: `${baseURL}/Agents/getCategory`,
  getStatus: `${baseURL}/Agents/getStatus`,
  getAllStatus: `${baseURL}/Agents/getStatus`,
  changeStatus: `${baseURL}/Agents/changeStatus`,

  //agent comments
  //deal notes
  createDeal: `${baseURL}/deals`,
  addNotes: `${baseURL}/deals/notes`,
  getAllNotes: `${baseURL}/deals/notes`,
  deleteNotes: `${baseURL}/deals/notes`,

  //deal stage history
  getstageHistories: `${baseURL}/deals/stageHistories`,

  //deal file upload
  getAllFiles: `${baseURL}/deals/files`,
  uploadFiles: `${baseURL}/deals/upload`,
  downloadFiles: `${baseURL}/deals/files/download`,
  deleteFiles: `${baseURL}/deals/files`,

  //deal timeline
  createTimeline: `${baseURL}/deals/add-timeline`,
  getAllTimeline: `${baseURL}/deals/timeline/:dealId`,

  //deal activity
  getAllActivityDetails: `${baseURL}/deals/activity/details`,

  // new routes new admin routes
  loginAdmin: `${baseURL}/admin/new-login`,
  createAdmin: `${baseURL}/admin/create`,
  getAllAdmins: `${baseURL}/admin/all`,
  updateAdmin: `${baseURL}/admin/update`,
  deleteAdmin: `${baseURL}/admin/delete`,
  getAllDids: `${baseURL}/admin/dids`,
  getDashboardDetails: `${baseURL}/admin/dashboard-details`,
  getClientCallDetails: `${baseURL}/admin/client-call-details`,
  getClientDetailedCallLogs: `${baseURL}/admin/client-call-logs`,
  getAuditHistory: `${baseURL}/admin/audit-history`,
  getDashboardV2Data: `${baseURL}/user/dashboard-v2`,

  // revenue module
  getRevenues: `${baseURL}/admin/get-revenue`,
  getRevenueAnalytics: `${baseURL}/admin/revenue-analytics`,
  createOrUpdateRevenue: `${baseURL}/admin/revenue`,
  assignAccountManager: `${baseURL}/admin/assign-account-manager`,
  toggleRenewalReminder: `${baseURL}/admin/toggle-renewal-reminder`,
  loginAsUser: `${baseURL}/admin/login-as-user`,

  //edit user by admin
  updateUser: `${baseURL}/admin/user`,

  // did apis
  getAllDids: `${baseURL}/admin/dids`,
  adminDid: `${baseURL}/admin/dids`,

  //team management by admin
  addTeamMember: `${baseURL}/admin/add-team-member`,
  getTeamMembersByClientId: `${baseURL}/admin/team-members/client`,
  updateTeamMember: `${baseURL}/admin/team-members`,
  deleteTeamMember: `${baseURL}/admin/team-members`,

  ///
  assignUserToDeal: `${baseURL}/deals`, // we will append /:dealId/assign
  getSingleTeamMember: `${baseURL}/admin/team-members`,

  // Public Lead Capture
  submitPublicLead: `${baseURL}/leads/public/submit`,

  // Google Sheets Integration
  googleSheetsAuthUrl: `${baseURL}/google-sheets/auth-url`,
  googleSheetsLink: `${baseURL}/google-sheets/link`,
  googleSheetsSync: `${baseURL}/google-sheets/sync`,
  googleSheetsStatus: `${baseURL}/google-sheets/status`,
  googleSheetsUnlink: `${baseURL}/google-sheets/unlink`,

  // meta leads
  metaAuthUrl: `${baseURL}/meta/auth-url`,
  metaStatus: `${baseURL}/meta/status`,
  metaLeads: `${baseURL}/meta/leads`,
  metaDisconnect: `${baseURL}/meta/disconnect`,
  metaSettings: `${baseURL}/meta/sync-settings`,
  metaManualSync: `${baseURL}/meta/manual-sync`,
  metaForms: `${baseURL}/meta/forms`,
  metaFormsSync: `${baseURL}/meta/forms/sync`,
  autoAssignConfig: `${baseURL}/user`, // We'll append /:userId/auto-assign-config

  // Categories (Dynamic Interest)
  getCategories: `${baseURL}/categories`,       // append /:userId
  createCategory: `${baseURL}/categories`,
  addSubCategory: `${baseURL}/categories`,      // append /:id/sub-category
  deleteCategory: `${baseURL}/categories`,      // append /:id
  deleteSubCategory: `${baseURL}/categories`,   // append /:id/sub-category/:subName

  // Dynamic Options (Age, City, etc.)
  getDynamicOptions: `${baseURL}/dynamic-options`,  // append /:userId?type=[age|city]
  createDynamicOption: `${baseURL}/dynamic-options`,
  deleteDynamicOption: `${baseURL}/dynamic-options`, // append /:id
  getGlobalLatestLeads: `${baseURL}/campaigns/global/latest`,
};

export default apiEndPointsConfig;
